export default {
  mounted(el) {
    const loadImage = () => {
      const src = el.getAttribute("data-src");
      if (src) {
        el.src = src;
      }
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        loadImage();
        observer.unobserve(el);
      }
    });

    observer.observe(el);
  },
};
